import { render, staticRenderFns } from "./media-types.vue?vue&type=template&id=c3629f56&"
import script from "./media-types.vue?vue&type=script&lang=js&"
export * from "./media-types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports